module.exports = __webpack_public_path__ + "img/10.fffc3948.jpg";